import PerspectiveCard from '../PerspectiveCard';
import useRefreshPerspectives from '../useRefreshPerspectives';
import { AddCircle as AddIcon } from '@mui/icons-material';
import AddButton from '../AddPerspective/AddButton';
import React, { useState } from 'react';
import Space from '@/components/Space';
import PushToRight from '@/components/PushToRight';
import api from '@/lib/api';
import PerspectiveCardContent from '../PerspectiveCard/PerspectiveCardContent';
import TextFieldWithEscListener from '@/components/TextFieldWithEscListener';
import { type Perspective } from '@/routes/perspectives/types';
import { Button } from '@mui/material';

type AddPerspectiveSublevelProps = {
  perspective: Perspective;
  parentId: number | null;
};

const AddPerspectiveSublevel = ({
  perspective,
  parentId,
}: AddPerspectiveSublevelProps) => {
  const refreshPerspectives = useRefreshPerspectives();

  const [name, setName] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  const [saving, setSaving] = useState(false);

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();

    setSaving(true);

    const apiEndpoint =
      parentId === null
        ? `/perspectives/sublevels/${perspective.id}/root`
        : `/perspectives/sublevels/${perspective.id}?parentId=${parentId}`;

    await api.post(apiEndpoint, {
      name,
    });

    await refreshPerspectives();

    setSaving(false);
    setShowAddForm(false);
    setName('');
  };

  return (
    <PerspectiveCard>
      {showAddForm ? (
        <PerspectiveCardContent>
          <form onSubmit={handleAdd}>
            <TextFieldWithEscListener
              label="Name"
              size="small"
              value={name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setName(e.target.value)
              }
              onEscPress={() => setShowAddForm(false)}
              fullWidth
              autoFocus
            />
            <Space height={12} />
            <PushToRight>
              <Button
                variant="contained"
                size="small"
                type="submit"
                loading={saving}
                disabled={name.trim().length === 0}
                disableElevation
              >
                Add
              </Button>
            </PushToRight>
          </form>
        </PerspectiveCardContent>
      ) : (
        <AddButton onClick={() => setShowAddForm(true)}>
          <AddIcon />
          <h4>Add sublevel</h4>
        </AddButton>
      )}
    </PerspectiveCard>
  );
};

export default AddPerspectiveSublevel;
